import React, { createContext, useContext, useState, useEffect } from 'react';
import { getClinics, getSpecialties, getCountries, getCities } from '../services/api';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [clinics, setClinics] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [clinicsData, specialtiesData, countriesData, citiesData] = await Promise.all([
          getClinics(),
          getSpecialties(),
          getCountries(),
          getCities()
        ]);
        
        setClinics(clinicsData);
        setSpecialties(specialtiesData);
        setCountries(countriesData);
        setCities(citiesData);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const refreshClinics = async (filters) => {
    try {
      const clinicsData = await getClinics(filters);
      setClinics(clinicsData);
    } catch (error) {
      console.error('Error refreshing clinics:', error);
    }
  };

  return (
    <DataContext.Provider
      value={{
        clinics,
        specialties,
        countries,
        cities,
        loading,
        refreshClinics
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
